// Das SmartAI-Panel von außerhalb öffnen — etwa aus dem Hero-CTA, der während
// der Urlaubssperre statt „Online Termin buchen" einen Rückruf anbietet.
//
// Bewusst ein DOM-Event statt eines Contexts: das Panel hängt in App.tsx neben
// den Routen, der Hero tief in einer Seite. Ein Context müsste durch die halbe
// Anwendung gereicht werden, nur für diesen einen Sprung. Das Panel meldet mit
// preventDefault, dass es den Wunsch übernommen hat; bleibt das aus (Feature
// aus, Konfiguration nicht geladen), kann der Aufrufer einen anderen Weg
// gehen, statt dass nichts passiert.

import type { HomeAction } from './v2/SmartAIHomeV2';

export const SMARTAI_OPEN_EVENT = 'smartai:open';

export interface SmartAIOpenDetail {
  action?: HomeAction;
}

/** @returns true, wenn ein gemountetes Panel den Wunsch übernommen hat. */
export function openSmartAI(action?: HomeAction): boolean {
  if (typeof window === 'undefined') return false;
  const ev = new CustomEvent<SmartAIOpenDetail>(SMARTAI_OPEN_EVENT, {
    cancelable: true,
    detail: { action },
  });
  return !window.dispatchEvent(ev);
}
